import { render, staticRenderFns } from "./BillingHandlingOutAdditionalIndex.vue?vue&type=template&id=16e64b7a&scoped=true&"
import script from "./BillingHandlingOutAdditionalIndex.vue?vue&type=script&lang=js&"
export * from "./BillingHandlingOutAdditionalIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingHandlingOutAdditionalIndex.vue?vue&type=style&index=0&id=16e64b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e64b7a",
  null
  
)

export default component.exports